import { StackedCards } from '@sorare/core/src/atoms/icons/StackedCards';
import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { useGQLSearchContext } from '@sorare/core/src/contexts/graphql-search';
import { useQueryString } from '@sorare/core/src/hooks/useQueryString';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';

import { ButtonGroup } from './ButtonGroup.tsx';
import { CardSymbol } from './index.tsx';

export const BackendStackedSwitch = () => {
  const track = useEvents();
  const ctx = useGQLSearchContext()!;
  const unstacked = !!useQueryString(SEARCH_PARAMS.UNSTACKED);

  const toggle = (unstack: boolean) => {
    ctx.setSearchParams(searchParams => {
      searchParams.delete(SEARCH_PARAMS.PAGE);
      if (unstack) {
        searchParams.set(SEARCH_PARAMS.UNSTACKED, 'true');
      } else {
        searchParams.delete(SEARCH_PARAMS.UNSTACKED);
      }
      return searchParams;
    });
    track('Switch Stacked View', {
      stacked: !unstack,
    });
  };

  const currentValue = unstacked ? 1 : 0;

  return (
    <ButtonGroup
      value={currentValue}
      onChange={index => currentValue !== index && toggle(index === 1)}
    >
      <StackedCards />
      <CardSymbol />
    </ButtonGroup>
  );
};
